import React from "react";
import { Typography, TypographyProps } from "@mui/material";

type DtLabelSize = "small" | "medium" | "large";

interface DtLabelProps extends TypographyProps {
  size?: DtLabelSize;
  color?: TypographyProps["color"];
}

const sizeMap: Record<DtLabelSize, string> = {
  small: "0.82rem",
  medium: "0.92rem",
  large: "1rem",
};

const DtLabel: React.FC<DtLabelProps> = ({
  children,
  sx,
  size = "large",
  color = "text.secondary",
  ...props
}) => (
  <Typography
    color={color}
    sx={{
      fontWeight: 500,
      fontSize: sizeMap[size],
      letterSpacing: 0.10,
      lineHeight: 1.4,
      mb: 0.5,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Typography>
);

export { DtLabel };